// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'E:/www/yc-qy-front-react/node_modules/.pnpm/@umijs+renderer-react@4.6.1_81c91584ac4c64f028bd91c1fd2a4eaf/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
